/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, Input } from '@angular/core';

import { EventService } from '../../services/event.service';

import { Constants, EmailType } from '../../global/constants';

@Component({
  selector: 'wf-description',
  templateUrl: './wf-description.component.html'
})
export class WfDescriptionComponent implements OnInit {

  @Input() workflow: any;

  output: any = {};

  filterCounts: any = {
    sender: { count: 0 },
    field: { count: 0 },
    static: { count: 0 },
    include: { count: 0 },
    exclude: { count: 0 }
  };

  constructor(private eventService: EventService,
              private constants: Constants) {
    this.eventService.toggleAllWorkflowDetails$.subscribe(
      show => {
        if (this.output.hasDetail) {
          this.output.details = show;
        }
      }
    )
  }

  ngOnInit() {
    if (this.workflow.trigger.data == 'contacts') {
      this.initContactType();
    }
    else if (this.workflow.trigger.data == 'recipient') {
      this.initSenderType();
    }
    else if (this.workflow.type == 'alert') {
      this.initAlertType();
    }
  }

  initContactType() {
    this.initOutput();
    this.output.type = 'contacts';
    this.output.partner = this.workflow.partner;
    this.output.list = this.workflow.action.list.name ? this.workflow.action.list.name : '';
    this.output.quality.high = this.workflow.trigger.confidence.indexOf(1) >= 0;
    this.output.quality.med = this.workflow.trigger.confidence.indexOf(2) >= 0;
    this.output.quality.low = this.workflow.trigger.confidence.indexOf(3) >= 0;

    for (var idx=0; idx<this.workflow.trigger.type.length; idx++) {
      this.output.emailTypes += this.constants.emailTypes.find((et) => {
                                   return et.typeName == this.workflow.trigger.type[idx];
                                 }).display;

      if (this.workflow.trigger.type.length > idx + 2) {
        this.output.emailTypes += ', ';
      }
      else if  (this.workflow.trigger.type.length > idx + 1) {
        this.output.emailTypes += ' and ';
      }
    }

    this.workflow.action.fields.forEach((f) => {
      this.output.fields.push({type:'field', description: f.description});
      this.output.hasFields = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.recipient_fields.forEach((f) => {
      this.output.fields.push({type:'sender', description: f.description});
      this.output.hasSenderFields = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.static_fields.forEach((f) => {
      this.output.fields.push({type:'static', description: f.description});
      this.output.hasStaticFields = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.include_filters.forEach((f) => {
      this.output.filters.push({type:'include', description: f.display, values: f.values});
      this.output.hasIncludeFilters = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.exclude_filters.forEach((f) => {
      this.output.filters.push({type:'exclude', description: f.display, values: f.values});
      this.output.hasExcludeFilters = true;
      this.output.hasDetail = true;
    });

    if (this.output.emailTypes.length == 0) {
      this.output.valid = false;
      this.output.invalidDesc = 'Incomplete (draft) workflow: you must specify at least one reply type.';
    }
    else if (this.output.partner == 'acton' && this.output.list.length == 0) {
      this.output.valid = false;
      this.output.invalidDesc = 'Incomplete (draft) workflow: you must specify a list to enable this workflow.';
    }
  }

  initSenderType() {
    this.initOutput();
    this.output.type = 'sender';
    this.output.partner = this.workflow.partner;
    this.output.list = this.workflow.action.list.name ? this.workflow.action.list.name : '';

    for (var idx=0; idx<this.workflow.trigger.type.length; idx++) {
      this.output.emailTypes += this.constants.emailTypes.find((et) => {
                                   return et.typeName == this.workflow.trigger.type[idx];
                                 }).display;

      if (this.workflow.trigger.type.length > idx + 2) {
        this.output.emailTypes += ', ';
      }
      else if  (this.workflow.trigger.type.length > idx + 1) {
        this.output.emailTypes += ' and ';
      }
    }

    this.workflow.action.fields.forEach((f) => {
      this.output.fields.push({type:'field', description: f.description});
      this.output.hasFields = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.static_fields.forEach((f) => {
      this.output.fields.push({type:'static', description: f.description});
      this.output.hasStaticFields = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.include_filters.forEach((f) => {
      this.output.filters.push({type:'include', description: f.display, values: f.values});
      this.output.hasIncludeFilters = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.exclude_filters.forEach((f) => {
      this.output.filters.push({type:'exclude', description: f.display, values: f.values});
      this.output.hasExcludeFilters = true;
      this.output.hasDetail = true;
    });

    if (this.output.emailTypes.length == 0) {
      this.output.valid = false;
      this.output.invalidDesc = 'Incomplete (draft) workflow: you must specify at least one reply type.';
    }
    else if (this.output.list.length == 0 && this.output.fields.length == 0) {
      this.output.valid = false;
      this.output.invalidDesc = 'Incomplete (draft) workflow: you must specify a list or map at least one field to enable this workflow.';
    }
  }

  initAlertType() {
    this.initOutput();
    this.output.type = 'alert';
    this.output.partner = this.workflow.partner;

    this.output.dynamic = this.workflow.action.domain;
    this.output.forwards = this.workflow.action.forwards;

    for (var idx=0; idx<this.workflow.trigger.type.length; idx++) {
      this.output.emailTypes += this.constants.emailTypes.find((et) => {
                                   return et.typeName == this.workflow.trigger.type[idx];
                                 }).display;

      if (this.workflow.trigger.type.length > idx + 2) {
        this.output.emailTypes += ', ';
      }
      else if  (this.workflow.trigger.type.length > idx + 1) {
        this.output.emailTypes += ' and ';
      }
    }

    this.workflow.action.include_filters.forEach((f) => {
      this.output.filters.push({type:'include', description: f.display, values: f.values});
      this.output.hasIncludeFilters = true;
      this.output.hasDetail = true;
    });

    this.workflow.action.exclude_filters.forEach((f) => {
      this.output.filters.push({type:'exclude', description: f.display, values: f.values});
      this.output.hasExcludeFilters = true;
      this.output.hasDetail = true;
    });

    if (this.output.emailTypes.length == 0) {
      this.output.valid = false;
      this.output.invalidDesc = 'Incomplete (draft) workflow: you must specify at least one reply type.';
    }
    else if (this.output.dynamic.length == 0 && this.output.forwards.length == 0) {
      this.output.valid = false;
      this.output.invalidDesc = 'Incomplete (draft) workflow: you must specify at least one recipient to enable this workflow.';
    }
  }

  initOutput() {
    this.output = {
      details: false,
      type: '',
      partner: '',
      emailTypes: '',
      quality: {
        high: false,
        med: false,
        low: false
      },
      list: '',
      fields: [],
      hasFields: false,
      hasSenderFields: false,
      hasStaticFields: false,
      filters:[],
      hasIncludeFilters: false,
      hasExcludeFilters: false,
      hasDetail: false,
      dynamic: '',
      forwards:[],
      valid: true,
      invalidDesc: ''
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/config/workflows/wf-description.component.ts